module.exports = __webpack_public_path__ + "img/BE0879257191.f39ee6b4.png";